import { CDN_DNS } from './images.constants';
import { BACKOFFICE_LOGO } from 'basics/constants/images.constants';
import { BiogenProduct, BiogenTherapeuticArea } from 'basics/enums/biogen.enums';
import { ConfigModule } from 'basics/enums/general.enums';

export const LAUNCH_DARKLY_COMMON_USER_KEY = 'common';
export const BACKOFFICE_TITLE = 'BiogenLinc Backoffice';
export const APP_TITLE = `Biogen ${BACKOFFICE_TITLE}`;
export const SUPPORT_EMAIL = 'https://reqform.mybiogen.net/#/other-requests/other';
export const cdnTemplatesPath = `https://${CDN_DNS}/templates`;
export const cdnDocumentsPath = `https://${CDN_DNS}/documents`;
export const TIME_60_MINUTES_IN_MS = 60 * 60 * 1000;
export const TIME_ONE_MINUTE_IN_SECONDS = 60;
export const TIME_FIVE_MINUTES_IN_SECONDS = 5 * 60;
export const TIME_ONE_SECOND_IN_MS = 1000;
export const TIME_ONE_SECOND_IN_SECONDS = 1;
export const appBarHeight = '6rem';
export const ONE_WEEK_IN_HOURS = 168;

export const MAYA_TITLE = 'BiogenLinc Maya';
export const SUPPORT_MAYA_EMAIL = 'https://reqform.mybiogen.net/#/other-requests/other';
export const MAYA_GRAPHQL_ENDPOINT = 'maya_endpoint';
export const MAYA_TARGETS_TEMPLATE = `${cdnTemplatesPath}/backOffice/templateTargetList.csv`;

export const EVENT_TITLE = 'BiogenLinc Events';
export const SUPPORT_EVENT_EMAIL = 'https://reqform.mybiogen.net/#/other-requests/other';
export const EVENT_GRAPHQL_ENDPOINT = 'event_endpoint';

export const MODULES_CONFIG = {
  [ConfigModule.Events]: {
    logo: `${BACKOFFICE_LOGO}`,
    module: 'events',
    path: '/events',
    support: `${SUPPORT_EVENT_EMAIL}`,
    title: `${EVENT_TITLE}`,
    context: { clientName: EVENT_GRAPHQL_ENDPOINT },
    enableCountrySelector: true,
    noLayoutURL: [],
  },
  [ConfigModule.Default]: {
    logo: `${BACKOFFICE_LOGO}`,
    module: '',
    path: '/',
    support: `${SUPPORT_EMAIL}`,
    title: `${BACKOFFICE_TITLE}`,
    context: { clientName: EVENT_GRAPHQL_ENDPOINT },
    enableCountrySelector: true,
    noLayoutURL: [],
  },
};

const TAListProducts = {
  [BiogenTherapeuticArea.ALZHEIMER]: [
    BiogenProduct.Aducanumab,
  ],
  [BiogenTherapeuticArea.BIOSIMS]: [
    BiogenProduct.Benepali,
    BiogenProduct.Biosimilar,
    BiogenProduct.Byooviz,
    BiogenProduct.Flixabi,
    BiogenProduct.Imraldi,
  ],
  [BiogenTherapeuticArea.FA]: [
    BiogenProduct.Omaveloxolone,
    BiogenProduct.Skyclarys,
  ],
  [BiogenTherapeuticArea.MS]: [
    BiogenProduct.Avonex,
    BiogenProduct.Fampyra,
    BiogenProduct.MS_Portfolio,
    BiogenProduct.Plegridy_IM,
    BiogenProduct.Plegridy,
    BiogenProduct.Tecfidera,
    BiogenProduct.Tysabri_IV,
    BiogenProduct.Tysabri,
    BiogenProduct.Vumerity,
  ],
  [BiogenTherapeuticArea.NONE]: [
    BiogenProduct.Biogen,
  ],
  [BiogenTherapeuticArea.SMA]: [
    BiogenProduct.Spinraza,
  ],
};

export const therapeuticAreaRelativesProducts = Object.seal(TAListProducts);

